"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseGalleryPropTypes = void 0;

var prop_types_1 = __importDefault(require("prop-types"));

exports.baseGalleryPropTypes = {
  children: prop_types_1.default.any,
  options: prop_types_1.default.object,
  id: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number])
};